var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button"},[_c('span',{staticClass:"btn",attrs:{"role":"button"}},[_c('IcEdit',{staticClass:"icn"}),_vm._v(" 編集 ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }